import {
  Avatar,
  Box,
  Button,
  Card,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Paragraph from "../../../atoms/Paragraph";
import Title from "../../../atoms/Title";
import apiIcon from "../../../../Icons/apiIcon.png";
import OAuth2Authentication from "./OAuth2Authentication";
import UserConnectionStatus from "../UserConnectionTabs/UserConnectionStatus";
import {
  getOrgVariable,
  setUpOrgVariable,
} from "../../../../APICalling/ZohoAPICalling";
import { CREDENTIAL_OF_LOGIN_USER_SERVICE_API_NAME } from "../../../../config/serviceConstant";
import ZohoIcon from "../../../../Images/Zoho Logo.png";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import zoho__Logo from "../../../../Images/Zoho Logo.png";
import sharepoint__logo from "../../../../Images/SharePoint.png";
import workdrive__logo from "../../../../Images/Zoho Workdrive.png";

const ZOHO = window?.ZOHO;

function OAuth2Authenticator({
  orgId,
  apiKey,
  dataCenterUrl,
  dataCenter,
  zApiKey,
  setSnack,
  allUsers,
  currentUser,
  handlefetchConnections,
  service,
  setAuthServices,
}) {
  const [reload, setReload] = useState(false);
  const [serviceAuth, setServiceAuth] = useState(false);

  return (
    <>
      {service?.name === "Zoho" ? (
        <Box
          sx={{
            border: "1px solid #e0e0e0",
            borderRadius: 2,
            p: 2,
            backgroundColor: "#f9fbfd",
          }}
        >
          <Typography variant="subtitle1" fontWeight={600} mb={1}>
            Required Authentication
          </Typography>

          <Box
            variant="outlined"
            sx={{
              // display: "flex",
              // alignItems: "center",
              // justifyContent: "space-between",
              backgroundColor: "#fff",
              py: 7,
              px: 4,
              borderRadius: 2,
              border: "1px solid #D7E2ED",
            }}
          >
            <Grid container>
              <Grid item size={{ xl: 9 }}>
                <Box display="flex" alignItems="center" gap={2}>
                  <Avatar
                    src={ZohoIcon}
                    alt="Zoho Logo"
                    sx={{ width: 100, height: 100 }}
                  />
                  <Box>
                    <Stack direction="row" alignItems="center" gap={1}>
                      <Typography variant="subtitle1" fontWeight={600}>
                        Authenticate Zoho
                      </Typography>
                      <CheckCircleIcon fontSize="small" color="success" />
                    </Stack>
                    <Typography variant="body2" color="text.secondary" mt={0.5}>
                      {service?.description}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid
                item
                size={{ xl: 3 }}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Box>
                  <OAuth2Authentication
                    serviceAuth={serviceAuth}
                    setServiceAuth={setServiceAuth}
                    setAuthServices={setAuthServices}
                    orgId={orgId}
                    apiKey={apiKey}
                    dataCenterUrl={dataCenterUrl}
                    dataCenter={dataCenter}
                    zApiKey={zApiKey}
                    setSnack={setSnack}
                    service={service}
                    allUsers={allUsers}
                    currentUser={currentUser}
                    setReload={setReload}
                    reload={reload}
                    handlefetchConnections={handlefetchConnections}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      ) : (
        <Box
          variant="outlined"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            px: 1,
            pt: 1,
            height: "100%",
            borderRadius: 2,
            mx: 2,
            backgroundColor: "#fff",
            border: "1px solid #D7E2ED",
          }}
        >
          <Box
            sx={{
              bgcolor: "#F5F7F9",
              width: "100%",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              // padding: 5,
              gap: 3,
              borderRadius: "5px",
              textAlign: "left",
            }}
          >
            <Box
              component="img"
              src={
                service?.name === "Workdrive"
                  ? workdrive__logo
                  : service?.name === "Sharepoint"
                  ? sharepoint__logo
                  : null
              }
              alt={service?.name}
              sx={{ width: 100, height: 100, mb: 1 }}
            />
            <Box>
              <Typography variant="subtitle1" fontWeight={600}>
                {service?.name}
              </Typography>
              <Typography variant="body2" color="text.secondary" mb={2}>
                {service?.description}
              </Typography>
            </Box>
          </Box>
          <Box sx={{ py: 1 }}>
            <OAuth2Authentication
              serviceAuth={serviceAuth}
              setServiceAuth={setServiceAuth}
              setAuthServices={setAuthServices}
              orgId={orgId}
              apiKey={apiKey}
              dataCenterUrl={dataCenterUrl}
              dataCenter={dataCenter}
              zApiKey={zApiKey}
              setSnack={setSnack}
              service={service}
              allUsers={allUsers}
              currentUser={currentUser}
              setReload={setReload}
              reload={reload}
              handlefetchConnections={handlefetchConnections}
            />
          </Box>
        </Box>
      )}
    </>
  );
}

export default OAuth2Authenticator;
